module.exports = __webpack_public_path__ + "mn.svg?fe5a69c8e47626f17e4de358a447b2a2";